import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnChanges {

  @Input() rating: number;
  @Input() editable: boolean;
  @Output() ratingChange: EventEmitter<number> = new EventEmitter();
  originalRating: number;

  constructor() { }

  ngOnChanges() {
    this.originalRating = this.rating;
  }

  getPercent() {
    return `${(this.rating / 5) * 100}% `;
  }

  onMouseOver(event) {
    if (!this.editable) {
      return;
    }
    const width = $('.rating').width();
    const offset = event.offsetX;
    this.rating = Math.ceil((offset / width) * 5);
  }

  onMouseOut() {
    this.rating = this.originalRating;
  }

  saveRating() {
    this.originalRating = this.rating;
    this.ratingChange.emit(this.rating);
  }

}
